<template>
  <div class="company-logos">
    <img src="/src/assets/images/bepump.png" alt="Company Logo 1" width="200" />
    <img src="/src/assets/images/cluster.png" alt="Company Logo 1" width="200" />
    <img src="/src/assets/images/prointronic.png" alt="Company Logo 1" width="200" />
    <img src="/src/assets/images/solimec.png" alt="Company Logo 1" width="200" />

  </div>
</template>

<script setup lang="ts">
</script>

<style scoped>
.company-logos {
  display: flex;
    align-items: center;
    justify-content: center;
    gap: 120px;
    border-bottom: 2px solid;
    border-image: linear-gradient(to right, #FFFFFF, #E2E8F0, #FFFFFF) 1;
    width: 100%;
    overflow: auto;
}

.company-logos img {
  width: 20%;
  height: auto;
  filter: grayscale(100%);
  transition: filter 0.3s ease;
  cursor: pointer;
  max-width: 200px;
}

.company-logos img:hover {
  filter: grayscale(0);
}
@media (max-width: 768px) {
  .company-logos {
    gap: 10px;
  }
}
</style>
